import s from './styles.scss';
import cx from 'classnames';
import { Display } from './Display';
import { HeadingProps } from './types';

const Heading = ({
  level,
  children,
  className,
  ...restProps
}: HeadingProps): JSX.Element => {
  const HeadingElement = `h${level}` as 'h3' | 'h4' | 'h5' | 'h6';

  return (
    <HeadingElement className={cx(s.heading, className)} {...restProps}>
      {children}
    </HeadingElement>
  );
};

Heading.Display = Display;

export { Heading };
